import { render, staticRenderFns } from "./AppListView.vue?vue&type=template&id=c97d8ff2&"
import script from "./AppListView.vue?vue&type=script&lang=js&"
export * from "./AppListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports